/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  SlackDirectoryMember,
  SlackDirectoryMember$inboundSchema,
} from "./slackdirectorymember.js";

export type ListMembersResponseBody = {
  members: Array<SlackDirectoryMember>;
  /**
   * Time the mapping-state sort used. Pass it back to keep the order stable across pages and edits.
   */
  sortAsOf: Date;
  /**
   * Matching retained membership rows.
   */
  total: number;
};

/** @internal */
export const ListMembersResponseBody$inboundSchema: z.ZodMiniType<
  ListMembersResponseBody,
  unknown
> = z.pipe(
  z.object({
    members: z.array(SlackDirectoryMember$inboundSchema),
    sort_as_of: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    total: z.int(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "sort_as_of": "sortAsOf",
    });
  }),
);

export function listMembersResponseBodyFromJSON(
  jsonString: string,
): SafeParseResult<ListMembersResponseBody, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListMembersResponseBody$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListMembersResponseBody' from JSON`,
  );
}
